import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@Sage/hoi-poi-ui';
import { getFileExtensionIconName } from 'utils/files';

/**
 * Unified file icon component that uses hoi-poi-ui Icon component
 * with the file extension icon name helper
 */
const FileIcon = ({ extension, isLink, isFolder, size = 'medium', color, ...props }) => {
    // Handle folder case
    if (isFolder === true || isFolder === '1') {
        return <Icon name="folder" size={size} color={color} {...props} />;
    }

    // Get the icon name based on extension and link status
    const iconName = getFileExtensionIconName(extension, isLink);

    return <Icon name={iconName} size={size} color={color} {...props} />;
};

FileIcon.propTypes = {
    /** File extension (e.g., 'pdf', 'docx', 'jpg') */
    extension: PropTypes.string,
    /** Whether the file is a link (boolean or string '0'/'1') */
    isLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    /** Whether it's a folder (boolean or string '0'/'1') */
    isFolder: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    /** Size of the icon */
    size: PropTypes.oneOf(['raw', 'small', 'medium', 'large', 'big', 'huge']),
    /** Color of the icon */
    color: PropTypes.string,
};

export default FileIcon;
